import type { Runtime } from "@baton/core";
import { useQuery } from "@tanstack/react-query";
import { unreadCountQuery } from "../../app/queries.ts";

/**
 * SC-015-008, `contracts/client-api.md` § Notification freshness, `spec.md` US6 scenario 1:
 * the inbox badge reads `GET /workspaces/{ws}/notifications/unread-count` once on load
 * (its `staleTime` is infinite: `createQueryClient` registers that per workspace) and is
 * patched in place by `notification.created` through `createNotificationFreshness`, which
 * writes `data.unread` into this query when the shell applies the workspace stream
 * (`shell/realtime/useWorkspaceStream.ts`), which also re-reads it on a reconnect and on reset.
 */
export function useUnreadTotal(runtime: Runtime, ws: string): number {
  const query = useQuery(unreadCountQuery(runtime, ws));
  return query.data?.total ?? 0;
}
